import axios from "axios";
import React, { useEffect, useState, useMemo } from "react";
import Cookies from "universal-cookie";
import { useParams } from "react-router-dom";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import ActualizaEstadoOmEvaluador from "./ActualizaOmNoAgrupadaEva";
import AccionMejora from "../CargaOm/AccionMejora";

function OmNoAgrupadasEvaluador(props) {
  const cookie = new Cookies();
  let { id } = useParams();
  let { idSolicitud } = useParams();
  const [list1, setList1] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOmAsignacion/" +
        cookie.get("id") +
        "/" +
        id +
        "/" +
        idSolicitud,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const columns = useMemo(
    () => [
      { Header: "Id", accessor: "o.id" },
      { Header: "Estado Oportunidad", accessor: "o.estadoOportunidad" },
      { Header: "Origen", accessor: "o.origen" },
      {
        Header: "Descripción",
        accessor: "o.descripcion",
        Cell: ({ value }) => (
          <span style={{ fontSize: "12px", lineHeight: "0.2" }}>{value}</span>
        ),
      },
      {
        Header: "Evaluadores",
        accessor: "asignados",
        Cell: ({ value }) => {
          if (!value || value.length === 0) {
            return <span>Sin asignar</span>;
          }

          return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
              {value.map((e) => (
                <span
                  key={e.id}
                  style={{
                    background: "#e3f2fd",
                    padding: "3px 6px",
                    borderRadius: "8px",
                    fontSize: "11px",
                  }}
                >
                  {e.nombre}
                </span>
              ))}
            </div>
          );
        },
      },
      {
        Header: "Acción",
        accessor: "acciones",
        Cell: ({ row }) => <AccionMejora idOm={row.original.o.id} />,
      },
      {
        Header: "Actualizar Estado",
        accessor: "estado",
        Cell: ({ row }) => (
          <ActualizaEstadoOmEvaluador idOm={row.original.o.id} />
        ),
      },
    ],
    [],
  );

  const tableInstance = useTable(
    { columns, data: list1, initialState: { pageIndex: 0 } },
    useGlobalFilter,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    state: { pageIndex }, // Agregar pageIndex
    pageOptions, // Agregar pageOptions
  } = tableInstance;

  return (
    <div className="container">
      <div className="text-justify">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información No Agrupada
              </h6>
            </div>
            <div className="card-body">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={(e) => setGlobalFilter(e.target.value || undefined)}
                className="form-control form-control-user"
              />

              <br />
              <div className="table-responsive">
                <table {...getTableProps()} className="table table-bordered">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps()}>
                            {column.render("Header")}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                  className="btn btn-primary"
                >
                  Anterior
                </button>

                <span className="fw-bold">
                  Página {pageIndex + 1} de {pageOptions.length}
                </span>

                <button
                  className="btn btn-primary"
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                >
                  Siguiente
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OmNoAgrupadasEvaluador;
